import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { NotificationService } from '../../ui/notification/notification.service';
import { dossierIdDeLaRoute, refusVersAccueil } from '../page-arrivee';

/**
 * Dossier annuel : réservé aux collaborateurs autorisés à saisir dans le travail en cours du dossier
 * (isSaisieTravailAutorise, calculé par le resolver).
 * Si le dossier courant n'est pas encore celui de l'URL (rechargement, arrivée depuis la liste des dossiers,
 * changement de dossier : la garde passe avant le resolver), l'écran s'ouvre et refait la vérification.
 * Refus : message, puis accueil du dossier. Correctif par rapport à l'ancien : sans dossier dans l'URL, page d'arrivée
 * de l'utilisateur (versPageArrivee, comme les autres gardes) au lieu de la racine « / ».
 */
export const dossierDeTravailGuard: CanActivateFn = (route) => {
  const dossierService = inject(DossierService);
  const dossierId = dossierIdDeLaRoute(route);
  if (
    !dossierService.currentDossier.id ||
    (!!dossierId && dossierService.currentDossier.id !== dossierId) ||
    dossierService.currentDossier.isSaisieTravailAutorise
  ) {
    return true;
  }
  inject(NotificationService).erreur("Vous n’êtes pas autorisé à accéder au dossier annuel.");
  return refusVersAccueil(route);
};
